export default __webpack_public_path__ + "static/media/thumbnail.2aedb2d6.png";